export const getSearchErrors = state => state.storeLocator.searchError || {}
